export const getUpgradeLink = (): string => process.env.REACT_APP_UPGRADE_URL || 'https://buhalbu.com';